/**
 * Returns true if the user has granted microphone permissions, false otherwise.
 * Async, remember to await.
 * It always resolves so there is no need to catch rejections.
 * It will prompt the user to grant permissions if they have not interacted with the microphone yet.
 * For this reason, it is best used just before the mic is needed, and not preemtively.
 */
export const checkIsMicrophoneAllowed = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });
    stream?.getTracks()?.forEach(track => {
      track?.stop(); // This will close the active microphone
    });
    return true;
  } catch (e) {
    return false;
  }
};
